import type { ClientPlatform } from "../../types/experiment";
import { PlatformVersionEditor } from "../Shared/PlatformVersionEditor";

interface ClientVersionFilterProps {
  value: ClientPlatform;
  onChange: (value: ClientPlatform) => void;
}

export function ClientVersionFilter({ value, onChange }: ClientVersionFilterProps) {
  return <PlatformVersionEditor value={value} onChange={onChange} />;
}
